// @flow
let LOGGER = null
let LOGGING_CONTEXTS = []

/**
 * Append logging context to the contexts list.
 * Returns a function to remove the context from the list.
 * @param  {any} logger
 */
export const addLoggingContext = (context: any) => {
  LOGGING_CONTEXTS.push(context)
  return () => {
    LOGGING_CONTEXTS = LOGGING_CONTEXTS.filter((x) => x !== context)
  }
}

/**
 * Sets a global logger function that will log every call
 * to the logError function
 * @param  {any} logger
 */
export const setLogger = (logger: any) => {
  LOGGER = logger
}

/**
 * Small utility that log the error in all appropreate places
 * @param  {any} error
 */
export const logError = (error: any) => {
  console.error(error, LOGGING_CONTEXTS) // eslint-disable-line
  if (LOGGER) {
    LOGGER(error, LOGGING_CONTEXTS)
  }
}

export default logError
